<template>
  <div
    class="select-input"
    :class="{ open: showSelectPanel }"
    v-click-outside="handleClosePanel"
  >
    <input
      :value="value.text"
      type="text"
      readonly
      :style="disabled ? 'color:rgb(84,84,84)' : ''"
      :placeholder="placeholder"
      class="input flex1 stretch"
      @click="handleOpenPanel"
    />
    <img
      src="https://assets.rurushishi.com/yq-rs-make/huafa/img/down.png"
      v-if="!disabled"
      class="down-icon icon"
    />
    <div v-if="showSelectPanel" class="panel">
      <div
        v-for="item in dropData"
        :key="item.id"
        class="panel-item"
        :class="{ selected: item && item.id === value.id }"
        @click="handleSelectItem(item)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "./plugins/click-outside";

export default {
  name: "SelectInput",
  directives: {
    clickOutside: vClickOutside
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Object
    },
    placeholder: {
      type: String,
      default: ""
    },
    dropData: {
      type: Array,
      default: () => {
        return [
          { id: 1, text: "居民身份证" },
          { id: 2, text: "香港护照" },
          { id: 3, text: "台湾回乡证" }
        ];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSelectPanel: false
    };
  },
  methods: {
    handleOpenPanel() {
      if (this.disabled) return;
      this.showSelectPanel = !this.showSelectPanel;
    },
    handleClosePanel() {
      this.showSelectPanel = false;
    },
    handleSelectItem(item) {
      this.$emit("change", item);
      this.showSelectPanel = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 100%;
  height: 100%;
  .input {
    width: 100%;
    height: 100%;
  }
  .panel {
    position: absolute;
    top: 100%;
    left: 0.5rem;
    right: 0rem;
    z-index: 9;
    background: #ffffff;
    border: 0.02rem solid #dddddd;
    box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.14);
    border-radius: 0.02rem;
    .panel-item {
      font-size: 0.3rem;
      color: #4a4a4a;
      padding: 0.2rem 0.36rem;
      &:not(:last-child) {
        border-bottom: 0.02rem solid #dddddd;
      }
      &.selected {
        color: #ffffff;
        background: #f07b24;
      }
    }
  }
  &::after {
    position: absolute;
    content: "";
    right: 0.4rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.36rem;
    height: 0.36rem;
    background: url("~https://assets.rurushishi.com/yq-rs-make/huafa/img/down.png")
      no-repeat center center/0.36rem 0.36rem;
    transition: transform 0.5s;
  }
  &.open::after {
    transform: translateY(-50%) rotate(180deg);
  }
  .down-icon {
    position: absolute;
    top: 0.24rem;
    right: 0;
  }
}
</style>
